// React
import React from 'react';

export const ItemListFiles = ({
  item,
  index,
  isView,
  handleDelete,
  handleDownload,
}) => {
  const convertDateToBrazilFormat = (date) => {
    if (date !== null) {
      const [year, month, day] = date.split('-');

      const result = [day, month, year].join('/');
      return result;
    }
    return null;
  };

  return (
    <tr id={index} className="product" key={index}>
      <td className="product-id">{index !== undefined ? index + 1 : ''}</td>
      <td className="text-start">{item.name}</td>
      <td className="text-start">{item.size}</td>
      <td className="text-start">
        {convertDateToBrazilFormat(item.LastModified.slice(0, 10)) || '-'}
      </td>
      <td>
        <div className="hstack fs-15 gap-3">
          <div
            to="#"
            className="link-primary"
            onClick={() => {
              handleDownload(item);
            }}
            style={{
              cursor: 'pointer',
            }}
          >
            <i className="ri-download-line"></i>
          </div>
          {!isView && (
            <>
              <div
                to="#"
                className="link-primary"
                onClick={() => {
                  handleDelete(item.fullPath);
                }}
                style={{
                  cursor: 'pointer',
                }}
              >
                <i className="ri-delete-bin-line"></i>
              </div>
            </>
          )}
        </div>
      </td>
    </tr>
  );
};
